import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-screen-2xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                  酷客影院
                </span>
              </div>
              <p className="text-background-400 text-sm leading-relaxed">
                酷客影院致力于为广大影迷提供海量高清电影和高清电视剧在线观看服务，支持超清播放，画质清晰不缓冲，是您最佳的在线观影平台。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-background-50 font-semibold mb-4">
                <a href="/category/action" className="hover:text-primary-400 transition-colors">影视分类</a>
              </h4>
              <ul className="space-y-2.5">
                {[
                  { name: "动作片", slug: "action" },
                  { name: "科幻片", slug: "scifi" },
                  { name: "喜剧片", slug: "comedy" },
                  { name: "电视剧", slug: "tv-series" },
                  { name: "动画片", slug: "animation" },
                ].map((item) => (
                  <li key={item.slug}>
                    <Link
                      to={`/category/${item.slug}`}
                      className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-background-50 font-semibold mb-4">
                <a href="/about" className="hover:text-primary-400 transition-colors">关于我们</a>
              </h4>
              <ul className="space-y-2.5">
                {[
                  { name: "品牌介绍", to: "/about" },
                  { name: "用户口碑", to: "/about" },
                  { name: "联系我们", to: "/about" },
                  { name: "隐私政策", to: "/about" },
                  { name: "服务条款", to: "/about" },
                ].map((item) => (
                  <li key={item.name}>
                    <Link
                      to={item.to}
                      className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-background-50 font-semibold mb-4">
                联系我们
              </h4>
              <ul className="space-y-2.5">
                <li className="flex items-start gap-2 text-background-400 text-sm">
                  <i className="ri-mail-line text-primary-400 mt-0.5"></i>
                  <span>contact@kukecinema.com</span>
                </li>
                <li className="flex items-start gap-2 text-background-400 text-sm">
                  <i className="ri-phone-line text-primary-400 mt-0.5"></i>
                  <span>400-888-9999</span>
                </li>
                <li className="flex items-start gap-2 text-background-400 text-sm">
                  <i className="ri-map-pin-line text-primary-400 mt-0.5"></i>
                  <span>北京市朝阳区望京SOHO T1</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-800/60">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-background-500 text-xs">
                &copy; {currentYear} 酷客影院 KukeCinema.com 版权所有 | 仅供学习交流，请勿用于商业用途
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
                  <i className="ri-bilibili-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}